
import { sendPhoneOtp, verifyPhoneOtp, formatPhoneToE164 } from '../auth/phoneAuth';
import { supabase } from '@/integrations/supabase/client';

// Переэкспортируем основные функции
export * from './courierAuthOperations';
export * from './courierQueryOperations';
export * from './courierMutationOperations';
export * from './courierBase';
export * from './paymentMethodOperations';

// Дополнительные функции для авторизации курьеров с email
export const syncCourierWithAuthUser = async (userId: string, courierData: {
  phone?: string,
  email?: string,
  name?: string
}) => {
  try {
    // Проверяем существует ли запись в таблице profiles
    const { data: profileData, error: profileError } = await supabase
      .from('profiles')
      .select('*')
      .eq('id', userId)
      .maybeSingle();
      
    if (profileError) {
      console.error('Ошибка при проверке профиля:', profileError);
      return { success: false, error: profileError };
    }
    
    // Если профиль существует, обновляем его
    if (profileData) {
      const { data, error } = await supabase
        .from('profiles')
        .update({
          phone: courierData.phone || profileData.phone,
          email: courierData.email || profileData.email, 
          name: courierData.name || profileData.name
        })
        .eq('id', userId)
        .select();
        
      if (error) {
        return { success: false, error };
      }
      
      return { success: true, data };
    } 
    // Если профиль не существует, создаем новый
    else {
      const { data, error } = await supabase
        .from('profiles')
        .insert([{
          id: userId,
          phone: courierData.phone || null,
          email: courierData.email || null,
          name: courierData.name || 'Пользователь',
          role: 'courier',
          avatar: `https://api.dicebear.com/7.x/avataaars/svg?seed=${userId}`
        }])
        .select();
        
      if (error) {
        return { success: false, error };
      }
      
      return { success: true, data };
    }
  } catch (error: any) {
    console.error('Ошибка синхронизации курьера с пользователем:', error);
    return { success: false, error };
  }
};

// Функция для обновления email курьера
export const updateCourierEmail = async (courierId: string, email: string) => {
  try {
    // Обновляем запись в таблице profiles
    const { data: profileData, error: profileError } = await supabase
      .from('profiles')
      .update({ email })
      .eq('id', courierId)
      .select();
      
    if (profileError) {
      console.error('Ошибка обновления email в профиле:', profileError);
      return { success: false, error: profileError };
    }
    
    // Обновляем запись в таблице couriers, если она существует
    const { data: courierData, error: courierError } = await supabase
      .from('couriers')
      .update({ email })
      .eq('id', courierId)
      .select();
      
    // Здесь ошибка не является критической, т.к. не всегда запись в couriers существует
    if (courierError) {
      console.warn('Предупреждение: не удалось обновить email в таблице couriers:', courierError);
    }
    
    return { success: true, data: profileData };
  } catch (error: any) {
    console.error('Ошибка при обновлении email курьера:', error);
    return { success: false, error };
  }
};
